module.exports = __webpack_public_path__ + "static/media/bacle-logo.66a4229a.png";